import { Typography } from '@mui/material';
import { Layout } from '@rumblefish/ui/Rumblefish23Theme';
import { NextHeadWithMeta } from '../NextHeadWithMeta';
import { ContactStellar } from './Contact';
import { Faq } from './Faq';
import { Hero } from './Hero';
import { StyledContainer, StyledTypographySmall } from './styles';
import { WhyRF } from './WhyRF';
import { WhyStellar } from './WhyStellar';
import { SorobanScanPromo } from './SorobanScanPromo';
import { StellarCommunityFund } from './StellarCommunityFund';
import { stellarProductDevelopmentSeo } from './stellarProductDevelopmentPage.seo';
import type { StellarProductDevelopmentPageProps } from './stellarProductDevelopmentPage.types';
import { StellarProductDevelopmentServices } from './StellarProductDevelopmentServices/StellarProductDevelopmentServices';
import { StellarDevelopmentProcess } from './StellarDevelopmentProcess';
import { OurWork } from './OurWork';

export const StellarProductDevelopmentPage = ({
  blogPosts,
  caseStudies,
}: StellarProductDevelopmentPageProps) => {
  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta {...stellarProductDevelopmentSeo} />
      <Hero />
      <StellarProductDevelopmentServices />
      <WhyStellar />
      <StellarCommunityFund />
      <SorobanScanPromo />
      <WhyRF />
      <StellarDevelopmentProcess />
      <OurWork caseStudies={caseStudies} />
      <Faq />
      <ContactStellar />
      <StyledContainer>
        <StyledTypographySmall>
          <Typography component="span" sx={{ fontWeight: '600' }}>
            Rumble Fish
          </Typography>
          <Typography component="span">
            &nbsp;- Stellar expertise at your service
          </Typography>
        </StyledTypographySmall>
      </StyledContainer>
    </Layout>
  );
};
